/**
* checks if a given method is available in the given context
* @param  {String}  method The method name to check for
* @param  {Object}  where  The Element or prototype to check the method for
* @return {Boolean}        Return true if the method is available, false if the method doesn't exist
*/
export function hasMethod(method, where) {

  if (!(method in where)) {

    return false;
  }

  return true;
}

// trigger event
export function triggerEvent(target, type, data) {

  let cEvent;

  if (document.createEvent) {

    cEvent = document.createEvent('Event');

    cEvent.initEvent(type, true, false);

    cEvent.data = data;

    target.dispatchEvent(cEvent);

  } else {

    cEvent = document.createEventObject();

    cEvent.data = data;

    target.fireEvent('on' + type, cEvent);
  }
}

export function getClosestByClass(el, targetClass) {
  if (el.closest) {
    return el.closest('.' + targetClass) || false;
  }

  if (el.tagName.toLowerCase() === 'body') {
    return false;
  }

  let parent = el.parentNode;

  if (
    !parent ||
    parent.tagName.toLowerCase() === 'body'
  ) {
    return false;
  }

  while (!parent.classList.contains(targetClass) && parent.tagName.toLowerCase() !== 'body') {
    parent = parent.parentNode;
  }

  return parent;
}

export function getClosestByAttribute(el, targetAttribute) {

  let parent = el.parentNode;

  while (!parent.getAttribute(targetAttribute) && parent.tagName.toLowerCase() !== 'body') {

    parent = parent.parentNode;
  }

  if (parent.tagName.toLowerCase() === 'body') {

    return false;
  }

  return parent;
}

export function isChildNode(el, checkNode) {

  if ('contains' in checkNode) {

    return checkNode.contains(el);

  } else {

    return !!(checkNode.compareDocumentPosition(el) % 16); // Node.DOCUMENT_POSITION_CONTAINED_BY
  }
}

export function transitionEndEventName() {
  const
    el = document.createElement('div'),
    transitions = {
      'transition': 'transitionend',
      'OTransition': 'otransitionend',  // oTransitionEnd in very old Opera
      'MozTransition': 'transitionend',
      'msTransitionEnd': 'msTransitionEnd',
      'WebkitTransition': 'webkitTransitionEnd'
    };

  for (let i in transitions) {
    if (transitions.hasOwnProperty(i) && el.style[i] !== undefined) {
      return transitions[i];
    }
  }

  //TODO: throw 'TransitionEnd event is not supported in this browser';
}

export function animationEndEventName() {
  const
    el = document.createElement('div'),
    animations = {
      'animation': 'animationend',
      'OAnimation': 'oanimationend',  // oAnimationEnd in very old Opera
      'MozAnimation': 'animationend',
      'msAnimationEnd': 'msAnimationEnd',
      'WebkitAnimation': 'webkitAnimationEnd'
    };

  for (let i in animations) {
    if (animations.hasOwnProperty(i) && el.style[i] !== undefined) {
      return animations[i];
    }
  }

  //TODO: throw 'TransitionEnd event is not supported in this browser';
}

/**
* Behaves the same as setTimeout except uses requestAnimationFrame() where possible for better performance
* @param {function} fn The callback function
* @param {int} delay The delay in milliseconds
*/

export function requestTimeout(fn, delay) {

  if (!window.requestAnimationFrame) {
    return window.setTimeout(fn, delay);
  }

  const start = new Date().getTime();
  const handle = {};

  function loop() {

    const current = new Date().getTime();
    const delta = current - start;

    delta >= delay ? fn.call() : handle.value = window.requestAnimationFrame(loop);
  }

  handle.value = window.requestAnimationFrame(loop);
  return handle;

}

export function isRetina() {
  let mediaQuery = `
  (-webkit-min-device-pixel-ratio: 1.5),
  (min--moz-device-pixel-ratio: 1.5),
  (-o-min-device-pixel-ratio: 3/2),
  (min-resolution: 1.5dppx)`;

  if (window.devicePixelRatio >= 1.5) {

    return true;
  }

  if (window.matchMedia && window.matchMedia(mediaQuery).matches) {

    return true;
  }

  return false;
}

export function htmlToElement(html) {

  const template = document.createElement('div');
  template.innerHTML = html;
  return template.firstChild;
}

export function serialize(form, isSpecial) {
  if (!form || form.nodeName !== 'FORM') {
    return;
  }
  const q = [];
  for (let i = form.elements.length - 1; i >= 0; i = i - 1) {
    // workaround for IE11 bug
    if (typeof form.elements[i].name === 'undefined') {
      continue;
    }
    if (form.elements[i].name === '' || isSpecial && form.elements[i].name.match(new RegExp('_select', 'g')) || isSpecial && form.elements[i].name.match(new RegExp('_visible', 'g'))) {
      continue;
    }
    switch (form.elements[i].nodeName) {
    case 'INPUT':
      switch (form.elements[i].type) {
      case 'text':
      case 'email':
      case 'hidden':
      case 'password':
      case 'button':
      case 'reset':
      case 'submit':
        q.push(form.elements[i].name + '=' + encodeURIComponent(form.elements[i].value));
        break;
      case 'checkbox':
      case 'radio':
        if (form.elements[i].checked) {
          q.push(form.elements[i].name + '=' + encodeURIComponent(form.elements[i].value));
        }
        break;
      }
      break;
    case 'file':
      break;
    case 'TEXTAREA':
      q.push(form.elements[i].name + '=' + encodeURIComponent(form.elements[i].value));
      break;
    case 'SELECT':
      switch (form.elements[i].type) {
      case 'select-one':
        q.push(form.elements[i].name + '=' + encodeURIComponent(form.elements[i].value));
        break;
      case 'select-multiple':
        for (let j = form.elements[i].options.length - 1; j >= 0; j = j - 1) {
          if (form.elements[i].options[j].selected) {
            q.push(form.elements[i].name + '=' + encodeURIComponent(form.elements[i].options[j].value));
          }
        }
        break;
      }
      break;
    case 'BUTTON':
      switch (form.elements[i].type) {
      case 'reset':
      case 'submit':
      case 'button':
        q.push(form.elements[i].name + '=' + encodeURIComponent(form.elements[i].value));
        break;
      }
      break;
    }
  }
  return q.join('&');
}

export function serializeAjaxForm(form) {
  // Setup our serialized data
  const serialized = [];

  // Loop through each field in the form
  for (let i = 0; i < form.elements.length; i++) {

    const field = form.elements[i];

    // Don't serialize fields without a name, submits, buttons, file and reset inputs, and disabled fields
    if (!field.name || field.disabled || field.type === 'file' || field.type === 'reset' || field.type === 'submit' || field.type === 'button') continue;

    // If a multi-select, get all selections
    if (field.type === 'select-multiple') {
      for (let n = 0; n < field.options.length; n++) {
        if (!field.options[n].selected) continue;
        serialized.push(encodeURIComponent(field.name) + "=" + encodeURIComponent(field.options[n].value));
      }
    }

    // Convert field data to a query string
    else if ((field.type !== 'checkbox' && field.type !== 'radio') || field.checked) {
      serialized.push(encodeURIComponent(field.name) + "=" + encodeURIComponent(field.value));
    }
  }

  return serialized.join('&');
}
